import ActivityFeed from './ActivityFeedView';

export default ActivityFeed;
